import AppLanguage from "./AppLanguage";
import TranslatableText, {TranslatableTextKey} from "./TranslatableText";

let currentLanguage = AppLanguage.RO;
let forceUpdate: (() => void) | null = null;

const getSavedLanguage = (): AppLanguage | null => {
    const savedLanguageString = localStorage.getItem('language');
    return Object.values(AppLanguage).includes(savedLanguageString as AppLanguage)
        ? (savedLanguageString as AppLanguage)
        : null
}

const LanguageHandler = {
    getLanguage: (): AppLanguage => currentLanguage,

    setLanguage: (language: AppLanguage): void => {
        if (currentLanguage !== language) {
            currentLanguage = language
            localStorage.setItem('language', language)
            forceUpdate?.();
        }
    },

    setInitialAppLanguage: (): void => {
        const savedLanguage = getSavedLanguage()
        // case language saved in local storage -> after first visit
        if (savedLanguage) {
            if (savedLanguage !== currentLanguage) {
                LanguageHandler.setLanguage(savedLanguage)
            }

            return
        }

        // case first visit -> get device's language
        try {
            const supportedLanguages = Object.values(AppLanguage);
            const {locale} = Intl.DateTimeFormat().resolvedOptions();
            const languageCode = locale.split("-")[0].toLowerCase()

            // check if device language is defined by us, otherwise
            // fallback to RO
            LanguageHandler.setLanguage(
                supportedLanguages.includes(languageCode as AppLanguage)
                    ? (languageCode as AppLanguage)
                    : AppLanguage.RO
            );
        } catch {
            console.error("Error getting device language")
        }
    },

    getTranslatedText: (key: TranslatableTextKey): string =>
        TranslatableText[key][currentLanguage],

    _setForceUpdate: (fn: () => void) => {
        forceUpdate = fn;
    }
}

export default LanguageHandler;